import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconRouter = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <rect width='18' height='7' x='3' y='13' rx='2' />
      <path d='M12 13V9' />
      <path d='M8.5 6.5a5 5 0 0 1 7 0' />
      <path d='M6 4a8.5 8.5 0 0 1 12 0' />
      <path d='M7 16.5h.01M10 16.5h.01' />
    </g>
  </SDIcon>
)

export default IconRouter
